import type { Waypoint } from "./routeTotalDistance";

export interface RouteGeoJSON {
  type: "FeatureCollection";
  features: Array<{
    type: "Feature";
    properties: {
      id?: string;
      pointIndex?: number;
      poiId?: string | null;
      routingMode?: "auto" | "manual";
      distance?: number;
      [key: string]: unknown;
    };
    geometry: {
      type: "Point" | "LineString";
      coordinates: number[] | number[][];
    };
  }>;
}

export function generateRouteGeoJSON(waypoints: Waypoint[]): RouteGeoJSON {
  const newRouteGeoJSON: RouteGeoJSON = {
    type: "FeatureCollection",
    features: [],
  };

  if (!waypoints || !Array.isArray(waypoints)) {
    return newRouteGeoJSON;
  }

  let userpointIndex = 1;
  let prevWaypointId: string | null = null;
  const lastIndex = waypoints.length - 1;
  for (const [index, wp] of waypoints.entries()) {
    const isTerminal = index === 0 || index === lastIndex;
    const isUserpoint = wp.userpoint !== false;
    const shouldShowIndex = isUserpoint || isTerminal;

    // Add waypoint as Point feature
    newRouteGeoJSON.features.push({
      type: "Feature",
      properties: {
        id: wp.id,
        ...(shouldShowIndex ? { pointIndex: userpointIndex } : {}),
        poiId: wp.poiId,
        routingMode: wp.routingMode,
        userpoint: wp.userpoint,
        isTerminal,
      },
      geometry: {
        type: "Point",
        coordinates: [wp.lngLat[0], wp.lngLat[1]],
      },
    });

    if (shouldShowIndex) {
      userpointIndex++;
    }

    // Add passage leading to waypoint as LineStrings
    if (wp.passage && Array.isArray(wp.passage)) {
      const recordedSegment = wp.tracked === true;
      for (const feature of wp.passage) {
        newRouteGeoJSON.features.push({
          ...feature,
          properties: {
            ...feature.properties,
            routingMode: wp.routingMode,
            // Backfill leg identity for older stored routes (used for drag-to-insert UX).
            toWaypointId: feature.properties?.toWaypointId ?? wp.id,
            fromWaypointId:
              feature.properties?.fromWaypointId ?? prevWaypointId,
            recordedSegment,
          },
        });
      }
    }

    prevWaypointId = wp.id;
  }

  return newRouteGeoJSON;
}
